import React from 'react'
import Questionbankmain from '../features/questionbank'

function Questionbank() {
  return (
    <div><Questionbankmain/></div>
  )
}

export default Questionbank